import React, { ReactNode } from 'react';
import { Header } from './Header';
import { Footer } from './basic/Footer';

export type AppFrameProps = { children: ReactNode };

export const AppFrame: React.FC<AppFrameProps> = ({ children }) => (
    <>
        <Header />
        {children}
        <Footer />
    </>
);
